// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skincare-cabinet {
    width: 100%;
    max-width: var(--layout-page-max);
    margin: 0 auto;
    display: flex;
    flex-direction: column;
}

/* Tablet and mobile: span full width */
@media (max-width: 1024px) {
  .skincare-cabinet {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .skincare-cabinet {
    padding: 0;
    overflow-x: hidden;
    width: 100%;
  }
  
  .cabinet-header {
    margin-bottom: var(--space-6);
  }
  
  .product-sections {
    gap: var(--space-6);
  }
  
  .product-section {
    gap: var(--space-4);
  }
}

.cabinet-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: var(--space-7);
}

.cabinet-content {
    flex: 1;
}

.product-sections {
    display: flex;
    flex-direction: column;
    gap: var(--space-6);
}

.product-section {
    display: flex;
    flex-direction: column;
    gap: var(--space-5);
    background: var(--color-surface);
    border: 1px solid var(--color-border-subtle);
    border-radius: var(--radius-md);
    padding: var(--space-6);
}

.section-header {
    color: var(--color-black);
}

.empty-section {
    text-align: center;
    padding: var(--space-5);
    background-color: var(--color-surface-muted);
    border-radius: var(--radius-sm);
    color: var(--text-tertiary);
}

.product-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: var(--space-5);
}

/* Spinning animation for refresh icon */
.spinning {
  animation: spin 1s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@media (max-width: 900px) {
  .product-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 640px) {
  .product-section {
    padding: var(--space-4);
  }

  .product-grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--space-3);
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/SkincareCabinet.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,iCAAiC;IACjC,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA,uCAAuC;AACvC;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gCAAgC;IAChC,4CAA4C;IAC5C,+BAA+B;IAC/B,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,uBAAuB;IACvB,4CAA4C;IAC5C,+BAA+B;IAC/B,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA,wCAAwC;AACxC;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,qCAAqC;IACrC,mBAAmB;EACrB;AACF","sourcesContent":[".skincare-cabinet {\n    width: 100%;\n    max-width: var(--layout-page-max);\n    margin: 0 auto;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Tablet and mobile: span full width */\n@media (max-width: 1024px) {\n  .skincare-cabinet {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .skincare-cabinet {\n    padding: 0;\n    overflow-x: hidden;\n    width: 100%;\n  }\n  \n  .cabinet-header {\n    margin-bottom: var(--space-6);\n  }\n  \n  .product-sections {\n    gap: var(--space-6);\n  }\n  \n  .product-section {\n    gap: var(--space-4);\n  }\n}\n\n.cabinet-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: var(--space-7);\n}\n\n.cabinet-content {\n    flex: 1;\n}\n\n.product-sections {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-6);\n}\n\n.product-section {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-5);\n    background: var(--color-surface);\n    border: 1px solid var(--color-border-subtle);\n    border-radius: var(--radius-md);\n    padding: var(--space-6);\n}\n\n.section-header {\n    color: var(--color-black);\n}\n\n.empty-section {\n    text-align: center;\n    padding: var(--space-5);\n    background-color: var(--color-surface-muted);\n    border-radius: var(--radius-sm);\n    color: var(--text-tertiary);\n}\n\n.product-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: var(--space-5);\n}\n\n/* Spinning animation for refresh icon */\n.spinning {\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@media (max-width: 900px) {\n  .product-grid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media (max-width: 640px) {\n  .product-section {\n    padding: var(--space-4);\n  }\n\n  .product-grid {\n    grid-template-columns: repeat(2, 1fr);\n    gap: var(--space-3);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
